var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"already-have-account"},[_vm._v(" "+_vm._s(_vm.$t('signIn.alreadyHaveAccount'))+" "),_c('router-link',{attrs:{"to":{ path: '/sign-in', query: _vm.routeQuery}}},[_c('span',{staticClass:"underline-animate"},[_vm._v(" "+_vm._s(_vm.$t('signIn.signIn__text'))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }